// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';
import { Tabs } from '../../../../generic-components/Tabs';
import { BILLS_TABS_OPTIONS, BILLS_TABS_OPTIONS_TEXTS } from './consts';
import { UnpaidBills } from './pages/UnpaidBills';
import { PaidBills } from './pages/PaidBills';
import { BillPreview } from './pages/BillPreview';
import BillsModalsHub from './components/BillsModalsHub';
import { useStore } from '../../../../store';
import { AddNewBillButton } from '../../components/AddNewBillButton';

export const BillsHub = () => {
  const resetUnpaidBillsSlice = useStore((state) => state.resetUnpaidBillsSlice);
  const resetPaidBillsSlice = useStore((state) => state.resetPaidBillsSlice);
  const resetAddBillSlice = useStore((state) => state.resetAddBillSlice);
  const [activeTab, setActiveTab] = useState<string>(BILLS_TABS_OPTIONS.UNPAID);
  const { t } = useTranslation();

  const handleTabClick = (tabName: string) => {
    if (tabName === BILLS_TABS_OPTIONS.UNPAID && activeTab !== BILLS_TABS_OPTIONS.UNPAID) resetUnpaidBillsSlice();
    else if (tabName === BILLS_TABS_OPTIONS.PAID && activeTab !== BILLS_TABS_OPTIONS.PAID) resetPaidBillsSlice();
    setTimeout(() => {
      setActiveTab(tabName);
    }, 0);
  };
  useEffect(() => {
    resetAddBillSlice();
  }, []);

  return (
    <div className='pr-[34px] h-full'>
      <div className='sticky top-0 z-[30] bg-bw01'>
        <Heading
          title={t('BILL_PAY.BILLS_HUB.TITLE')}
          className='font-metricRSemibold text-bw08 text-[20px] mb-[24px]'
          testId='BillsHub__title'
        />
        <Heading
          title={t('BILL_PAY.BILLS_HUB.SUBTITLE')}
          className='text-md font-metricR text-bw07 mt-[4px] mb-[20px]'
          testId='BillsHub__subtitle'
        />
        <div className='flex justify-between'>
          <Tabs
            testId='BillsHub__tabs'
            useNewColors
            leftTabName={t(BILLS_TABS_OPTIONS_TEXTS.UNPAID)}
            rightTabName={t(BILLS_TABS_OPTIONS_TEXTS.PAID)}
            activeTab={activeTab}
            onTabClick={(tabName) => handleTabClick(tabName)}
          />
          <AddNewBillButton />
        </div>
      </div>
      <div>
        {activeTab === BILLS_TABS_OPTIONS.UNPAID && <UnpaidBills />}
        {activeTab === BILLS_TABS_OPTIONS.PAID && <PaidBills />}
        <BillPreview />
        <BillsModalsHub />
      </div>
    </div>
  );
};
